<template>
  <page-view :title="cgfs=='12'?'谈判小组设置':'评标小组设置'">
    <template slot="action">
      <a-button class="ml-1 mr-1" type="primary" icon="rollback" @click="$router.go(-1)">返回</a-button>
      <a-button class="ml-1 mr-1" v-show="panes.length>0 && showExpertBut" type="primary" :loading="expertLoading" icon="sync"
                @click="getExpertList">获取专家列表
      </a-button>
      <a-button class="ml-1 mr-1" v-show="panes.length>0" type="primary" icon="" @click="showMm">密码生成
      </a-button>
      <writer :referId="projectId" attach-key="PBJL" writer-key="PBJL">评标纪律</writer>
      <writer :referId="projectId" attach-key="JDYCNS" writer-key="JDYCNS">监督员承诺书</writer>
      <NtkoViewSelector clerkTemplateKey="purchaser_review_file">采购人承诺书</NtkoViewSelector>
      <writer :referId="projectId" attach-key="QDB" writer-key="QDB">签到表</writer>
      <writer :referId="projectId" attach-key="ProjectBasicInformation" writer-key="ProjectBasicInformation">书面介绍材料</writer>
      <!--<writer :referId="projectId" attach-key="PWQDB" writer-key="PWQDB">评委签到表</writer>
      <writer :referId="projectId" attach-key="JDLXRYQDB" writer-key="JDLXRYQDB">监督列席人员签到表</writer>-->
    </template>
    <a-spin tip="正在加载项目数据..." :spinning="spinning">
      <a-card>
        <a-tabs type="card">
          <a-tab-pane v-for="pane in panes" :key="pane.key" :tab="pane.title">
            <pbxzsz-list :ref="'pbxzsz' + pane.packId" :packId="pane.packId" :xmid="projectId"
                         @success="afterSuccess"/>
          </a-tab-pane>
          <a-space slot="tabBarExtraContent">
            <div>电子签名</div>
            <a-switch style="margin-bottom: 5px" checked-children="开" un-checked-children="关"
                      v-model="project.openExpertSignature" @change="updateExpertSignatureByProject()"/>
          </a-space>
        </a-tabs>
        <pbxzsz-mm ref="pbxzszMm" :visible="modalPbxzszMmShow" @cancel="modalPbxzszMmShow = false"
        />
      </a-card>
    </a-spin>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import PbxzszList from './PbxzszList'
import PbxzszMm from './PbxzszMm'
import Writer from '@/views/bid/wrtiter/Writer'
import NtkoViewSelector from '@/components/selector/NtkoViewSelector'

export default {
  name: 'Pbxzsz',
  components: {
    PageView,
    PbxzszList,
    Writer,
    PbxzszMm,
    NtkoViewSelector
  },
  data () {
    return {
      projectId: this.$route.query.projectId,
      modalPbxzszMmShow: false,
      spinning: true,
      panes: [],
      cgfs: this.$route.query.cgfs,
      project: {
        openExpertSignature: false
      },
      expertLoading: false,
      showExpertBut: false
    }
  },
  created () {
    this.bidPacksList()
    this.getBidProject()
    this.checkZjSqToExpert()
  },
  methods: {
    //校验包组是否选了组长才能生成密码
    checkCanShowMm () {
      let that = this
      that.$http.get('/api/1/bidApply/pbxzsz/checkCanShowMm.json?xmid=' + that.projectId).then(function (res) {
        if (200 === res.code) {
          if (res.result.bzmcs.length > 0) {
            let content = ''
            for (let i = 0; i < res.result.bzmcs.length; i++) {
              if (content) {
                content += '、' + res.result.bzmcs[i]
              } else {
                content = res.result.bzmcs[i]
              }
            }
            content += '未设置评审小组组长。'
            that.$warning({
              title: '温馨提示',
              content: content,
              footer: ''
            })

          } else {
            that.showMm()
          }

        }
      })
    },
    async getExpertList () {
      let that = this
      try {
        that.expertLoading = true
        let res =  await that.$http.get('/api/1/zjcq/push/getExtractExpert', { params: { projectId: that.projectId } })
        if (res.code !== 200) {
          that.$error({
            title: '提示',
            content: res.msg || '获取专家失败',
          })
          return
        }
        that.afterSuccess('all')
        that.$info({
          title: '提示',
          content: '获取专家成功',
        })
      } catch (e) {
        that.$error({
          title: '提示',
          content: e.message || '获取专家失败',
        })
      } finally {
        that.expertLoading = false
      }
    },
    showMm () {
      let that = this
      that.$http.get('/api/1/bidApply/pbxzsz/getXmZjListByXmid.json?xmid=' + that.projectId).then(function (res) {
        if (200 === res.code) {
          if (res.result) {
            that.modalPbxzszMmShow = true
            that.$refs.pbxzszMm.checkMm(that.projectId)
          } else {
            that.$message.error('暂无专家，请先添加专家')
          }

        }
      })
    },
    async checkZjSqToExpert () {
      let that = this
        let res = await this.$http.get('/api/1/bidApply/zjcq/checkZjSqToExpert?projectId=' + that.projectId)
        if (res.code === 200) {
          that.showExpertBut = res.result
        }
    },
    async getBidProject () {
      const res = await this.$http.get('/api/1/bidApply/getBidXmxxById.json?xmId=' + this.projectId)
      if (res.code == 200) {
        this.project = res.result
      }
    },
    bidPacksList () {
      let that = this
      that.$http.get('/api/1/bidApply/getBidBzxxByXmId.json?xmId=' + that.projectId).then(function (res) {
        that.spinning = false
        that.panes = []
        that.bidPacksList = res.result
        if (res.result.length > 0) {
          for (let i = 0; i < res.result.length; i++) {
            that.panes.push({
              title: '包组 ' + (i + 1),
              packId: res.result[i].bzid,
              bzmc: res.result[i].bzmc,
              bzbh: res.result[i].bzbh,
              key: (i + 1),
            })
          }
        }
      })
    },
    afterSuccess (bzid) {
      if (bzid === 'all') {
        for (const pane of this.panes) {
          let domName = 'pbxzsz' + pane.packId
          this.$nextTick(() => {
            if (this.$refs[domName]) {
              this.$refs[domName][0].bidPackInfo()
            }
          })
        }
      } else {
        let domName = 'pbxzsz' + bzid
        this.$nextTick(() => {
          if (this.$refs[domName]) {
            this.$refs[domName][0].bidPackInfo()
          }
        })
      }
    },
    async updateExpertSignatureByProject () {
      const res = await this.$http.post('/api/1/bidApply/updateExpertSignatureByProject', this.project)
      if (res.code == 200) {
        this.$message.success('处理成功')
      }
    }
  }
}

</script>

<style scoped>

</style>
